import { createContext } from "react"

export const FormName = createContext(null)
